module.exports = require("rxjs/observable/defer");